import React from 'react';
import { Navigation } from './components/Navigation';
import { EventHero } from './components/EventHero';
import { FactsStrip } from './components/FactsStrip';
import { TrailerSection } from './components/TrailerSection';
import { GallerySection } from './components/GallerySection';
import { ScreeningRoom } from './components/ScreeningRoom';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink text-led selection:bg-ice selection:text-ink" data-id="element-0" data-mp="2mndr6j0sy8wn">
      <Navigation data-id="element-1" data-mp="31cte1nx7pu72" />
      <main data-id="element-2" data-mp="2wk08wyxu0jug">
        <EventHero data-id="element-3" data-mp="2wka02pum4x1q" />
        <FactsStrip data-id="element-4" data-mp="2wjqkvgwckmre" />
        <TrailerSection data-id="element-5" data-mp="2wiffjcn976y6" />
        <GallerySection data-id="element-6" data-mp="2whxd1y9zzwht" />
        <ScreeningRoom data-id="element-7" data-mp="28u5ysp4wd9dw" />
        <AboutSection data-id="element-8" data-mp="28te21azkd5m1" />
        <ContactSection data-id="element-9" data-mp="28suv0pbgc1ms" />
      </main>
      <Footer data-id="element-10" data-mp="23vci6nubd29i" />
    </div>;
}